import styled from '@emotion/styled';
import {
  COLOR_MUTED_TEXT,
  MOBILE_BREAKPOINT,
  COLOR_MUTED_BACKGROUND,
} from 'components/PaywallsShared/constants';
import { WarningMessage } from 'components/WarningMessage';

export const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 70px;
  text-align: center;
  background: ${COLOR_MUTED_BACKGROUND};
`;

export const Header = styled.h1`
  display: block;
  margin: 0 0 20px 0;
  font-weight: 800;
  font-size: 2.4rem;
`;

export const ContentContainer = styled.div`
  max-width: ${MOBILE_BREAKPOINT}px;
  color: ${COLOR_MUTED_TEXT};
  font-size: 1.6rem;
  line-height: 1.5;

  a {
    color: inherit;
  }
`;

export const PodcastName = styled.span`
  display: inline-block;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  button {
    white-space: nowrap;
  }
`;

export const StyledWarningMessage = styled(WarningMessage)`
  margin-top: 32px;
`;
